import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { some, head, reduce} from 'lodash'
import { updateOrderInProgress } from '../../actions/order'
import PropTypes from 'prop-types'

import { toast } from 'react-toastify'
import cn from 'classnames'

import styles from './EmailReceiptModal.module.scss'


const EmailReceiptModal = ({ onClose, order, sendEmails, paymentId, className }) => {
  const classNames = cn(styles.emailReceiptModal, className)
  const [emailInfo, setEmailInfo] = useState({ sFocused: false, isValid: true })

  const dispatch = useDispatch()

  const onEmailSubmit = () => {
    const emails = emailInfo.emails.replace(/\s/g, "").split(",")
    const emailRegex = /.+@.+\.+.+/i;
    const emailsAreValid = !(some(emails, (email) => !emailRegex.test(email))) || !emailInfo.emails.length

    if (emailsAreValid && head(emails).length) {
      if (order?.submittedAt) {
        sendEmails(order.uuid, emails, paymentId)
      } else {
        // if there is a paymentId, we save the emails to the payment attached to the order to be emailed upon order completion
        const payments = reduce(order.payments, (payments, payment) => {
          if (payment.paymentId === paymentId) {
            payment.emails = emails
          }
          return [
            ...payments,
            payment
          ]
        }, [])
        dispatch(updateOrderInProgress({
          payments,
        }))
        toast.success('Receipts will be emailed upon order completion')
      }
    } else {
      toast.error("Can't send email.")
    }
    setEmailInfo({ ...emailInfo, isValid: emailsAreValid })
    onClose()
  }

  return (
    <div className={classNames}>
      <div className={styles.overlay}></div>
      <div className={styles.content}>
        <div className={styles.body}>
          <p className={styles.emailText}>Enter Email</p>
          <p className={styles.emailSubtext}>Separate multiple emails with commas</p>
          <div className={styles.inputContainer}>
            <input autoFocus 
              type="text"
              value={emailInfo?.emails}
              onBlur={() => {
                setEmailInfo({ ...emailInfo, isFocused: false })
              }}
              onFocus={() => {
                setEmailInfo({ ...emailInfo, isFocused: true, isValid: true })
              }}
              onChange={e => setEmailInfo({ ...emailInfo, emails: e.target.value })}
            />
          </div>          
          <button
            onClick={onEmailSubmit}
            className={cn(styles.button, styles.sendButton)}
            disabled={!emailInfo.isValid || !emailInfo?.emails}
            >Send</button>
          <button
            onClick={onClose}
            className={cn(styles.button, styles.cancelButton)}
            >Cancel</button>
        </div>
      </div>
    </div>
  )
}

EmailReceiptModal.defaultProps = {
  onClose: () => {},
}

EmailReceiptModal.propTypes = {
  onClose: PropTypes.func,
}

export default EmailReceiptModal
